import type { JSX } from "solid-js";
import { t } from "../i18n";

/** Grip control used to start exercise reorder without fighting page scroll. */
export default function DragHandle(
  props: JSX.HTMLAttributes<HTMLButtonElement>,
) {
  return (
    <button
      type="button"
      aria-label={t("DRAG_REORDER")}
      {...props}
      class={`drag-handle inline-flex h-10 w-9 shrink-0 items-center justify-center rounded-xl text-ink-faint transition hover:bg-white/[0.05] hover:text-ink-muted active:text-ink ${
        props.class ?? ""
      }`}
    >
      <svg
        class="h-5 w-5"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <circle cx="9" cy="7" r="1.35" />
        <circle cx="15" cy="7" r="1.35" />
        <circle cx="9" cy="12" r="1.35" />
        <circle cx="15" cy="12" r="1.35" />
        <circle cx="9" cy="17" r="1.35" />
        <circle cx="15" cy="17" r="1.35" />
      </svg>
    </button>
  );
}
